export const Logo = ({ className = "h-9" }) => (
  <img
    src="/assets/sensorize-logo.png"
    alt="Sensorize STAT"
    className={className}
    data-testid="sensorize-logo"
  />
);

export default Logo;
